import SettingsLayout from '@portal/containers/settings/SettingsLayout';
import { SETTINGS_TAB_KEYS } from '@portal/containers/settings/SettingsTabs';
import { Route, Routes } from 'react-router-dom';
import { featureSupported } from '../featureFlagsUtils';
import EntraIdSuccess from './containers/entraId/EntraIdSuccess';
import { PortalLanding } from './containers/landing/PortalLanding';
import Settings from './containers/settings/Settings';
import { MfaRestrictedRoute } from './MfaRestrictedRoute';
import Portal from './index';

const ENABLE_LOGIN_ACTIVITY_REPORT = featureSupported('ENABLE_LOGIN_ACTIVITY_REPORT');
const ENABLE_EPCS = featureSupported('ENABLE_EPCS');
const ENABLE_ADVANCED_SETTINGS_TAB = featureSupported('ENABLE_ADVANCED_SETTINGS_TAB');
const ENABLE_ENDPOINTS = featureSupported('ENABLE_ENDPOINTS');

export enum PortalPath {
  SETTINGS = '/settings',
}

export enum SettingsPath {
  ENTRA_ID_USERS = '/settings/entra-users',
  IDENTITY_USERS = '/settings/identity-users',
  APPLICATIONS = '/settings/applications',
  SAML_IDP = '/settings/saml-idp',
  EAM_INTEGRATION = '/settings/eam-integration',
  VPAM_INTEGRATION = '/settings/vpam-integration',
  AIP_INTEGRATION = '/settings/aip-integration',
  IDV_CONNECTIONS = '/settings/oidc-integrations',
  SECURITY = '/settings/security',
  PASSWORD_POLICY = '/settings/password-policy',
  CUSTOMIZE = '/settings/customize',
  LOGIN_ACTIVITY_REPORT = '/settings/login-activity-report',
  EPCS_ACTIVITY_REPORT = '/settings/epcs-activity-report',
  ADVANCED_SETTINGS = '/settings/advanced-settings',
  ENDPOINTS = '/settings/endpoints',
}

const PortalRoutes = () => {
  return (
      <Routes>
        <Route path={'/'} element={<Portal />}>
          <Route index element={<PortalLanding />} />
          <Route
              path={'/entraid/auth-success'}
              element={
                <MfaRestrictedRoute>
                  <EntraIdSuccess />
                </MfaRestrictedRoute>
              }
          />
          <Route
              path={PortalPath.SETTINGS}
              element={
                <MfaRestrictedRoute>
                  <SettingsLayout />
                </MfaRestrictedRoute>
              }
          >
            <Route index element={<Settings activeTab={SETTINGS_TAB_KEYS.users} />} />
            <Route
                path={SettingsPath.ENTRA_ID_USERS}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.users} />}
            />
            <Route
                path={SettingsPath.IDENTITY_USERS}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.identityUsers} />}
            />
            <Route
                path={SettingsPath.APPLICATIONS}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.applications} />}
            />
            <Route
                path={SettingsPath.SAML_IDP}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.samlIdp} />}
            />
            <Route
                path={SettingsPath.EAM_INTEGRATION}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.eamIntegration} />}
            />
            <Route
                path={SettingsPath.VPAM_INTEGRATION}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.vpamIntegration} />}
            />
            <Route
                path={SettingsPath.AIP_INTEGRATION}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.aipIntegration} />}
            />
            <Route
                path={SettingsPath.IDV_CONNECTIONS}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.idvConnections} />}
            />
            {ENABLE_LOGIN_ACTIVITY_REPORT && (
                <Route
                    path={SettingsPath.LOGIN_ACTIVITY_REPORT}
                    element={<Settings activeTab={SETTINGS_TAB_KEYS.loginActivityReport} />}
                />
            )}
            {ENABLE_EPCS && (
                <Route
                    path={SettingsPath.EPCS_ACTIVITY_REPORT}
                    element={<Settings activeTab={SETTINGS_TAB_KEYS.epcsActivityReport} />}
                />
            )}
            <Route
                path={SettingsPath.SECURITY}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.security} />}
            />
            <Route
                path={SettingsPath.PASSWORD_POLICY}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.passwordPolicy} />}
            />
            <Route
                path={SettingsPath.CUSTOMIZE}
                element={<Settings activeTab={SETTINGS_TAB_KEYS.customize} />}
            />
            {ENABLE_ADVANCED_SETTINGS_TAB && (
                <Route
                    path={SettingsPath.ADVANCED_SETTINGS}
                    element={<Settings activeTab={SETTINGS_TAB_KEYS.advancedSettings} />}
                />
            )}
            {ENABLE_ENDPOINTS && (
                <Route
                    path={SettingsPath.ENDPOINTS}
                    element={<Settings activeTab={SETTINGS_TAB_KEYS.endpoints} />}
                />
            )}
          </Route>
        </Route>
      </Routes>
  );
};

export default PortalRoutes;